import { useLayoutEffect, useState } from 'react';

import { reportHeaderPart } from './headerOffsets';

/**
 * Measures a fixed header element and keeps its height published while it is mounted.
 * Returns a callback ref for the element.
 *
 * @param {'navbar'|'banner'} part
 */
export const useMeasuredHeaderPart = (part) => {
    const [element, setElement] = useState(null);

    useLayoutEffect(() => {
        if (!element) return undefined;

        const instance = {};
        const measure = () => reportHeaderPart(part, instance, element.offsetHeight);
        measure();

        // Keeps the offsets right while the banner slides in or its text wraps on rotation.
        const observer = new ResizeObserver(measure);
        observer.observe(element);

        return () => {
            observer.disconnect();
            reportHeaderPart(part, instance, null);
        };
    }, [element, part]);

    return setElement;
};
